import { Component, Input } from '@angular/core';
import { CitesImporterDetails } from 'src/app/core/models/cites/shared/CitesImporterDetails';
import { CitesBaseFormComponent } from '../base/CitesBaseFormComponent';

@Component({
  selector: 'app-cites-importer-form',
  templateUrl: './cites-importer-form.component.html',
})
export class CitesImporterFormComponent extends CitesBaseFormComponent {
  @Input()
  useImportingCountries: boolean = false;

  @Input()
  importerDetails: CitesImporterDetails;
}
